import React from 'react';
import '../../styles/component/header_footer/footer.css';
import { FaInstagram } from 'react-icons/fa';
import logo from '../../media/logo/Logo_nurleder.png';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-top">
                {/* Kontakt links */}
                <div className="footer-section contact-info">
                    <h4>📍 Kontakt</h4>
                    <p></p>
                    <p>info@nurleder.de</p>
                    <p>📱 +49 151 6155 9999</p>
                    <p>whats-App: +49 151 6155 9999</p>
                </div>

                {/* Logo zentriert */}
                <div className="footer-section footer-logo">
                    <img src={logo} alt="Logo" />
                </div>

                {/* Social rechts */}
                <div className="footer-section footer-social">
                    <h4>📷 Folge mir</h4>
                    <div className="social-icons">
                        <a href="https://www.instagram.com/alihandarbeit/" target="_blank" rel="noopener noreferrer">
                            <FaInstagram />
                        </a>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                © {new Date().getFullYear()} Nurleder – Alle Rechte vorbehalten

                <div className="footer-legal">
                    <a href="/impressum">Impressum</a>
                    <span>·</span>
                    <a href="/datenschutz">Datenschutz</a>
                </div>
            </div>

        </footer>
    );
}

export default Footer;
